import MapPath from './map-path.component';
export default MapPath;
